/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

export const SET_ACTIVE_COMPONENT = 'SET_ACTIVE_COMPONENT';
